import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

/**
 * Modal shown when a trial clinic makes a mutation request after expiry.
 * Listens for the custom 'trial-expired' event dispatched by the API interceptor.
 */
export const TrialExpiredModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('trial-expired', handler);
    return () => window.removeEventListener('trial-expired', handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md bg-[#22201E] rounded-2xl border border-[#F5F0EA]/10">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-red-400" />
            <DialogTitle className="font-['Fraunces'] text-[#F5F0EA]">Trial Expired</DialogTitle>
          </div>
          <DialogDescription className="font-['Inter'] text-[#F5F0EA]/50">
            Your free trial has ended. You can still view your data, but creating or editing
            records requires completing the full onboarding process.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:justify-end">
          <Button 
            variant="outline" 
            onClick={() => setOpen(false)}
            className="border border-[#F5F0EA]/15 text-[#F5F0EA] bg-transparent hover:bg-[#F5F0EA]/5 rounded-full font-['Montserrat'] font-medium"
          >
            Continue Browsing
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              navigate('/onboard/clinic?mode=convert');
            }}
            className="bg-[#B87A5D] hover:bg-[#A56A4D] text-white rounded-full font-['Montserrat'] font-medium"
          >
            Complete Onboarding
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
